module.exports = __webpack_public_path__ + "static/media/logo_gcm_agent.0ad29934.png";